export const vsComponentName = "lookupModal";
export const vsServiceName = "lookupModalService";
